var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: { href: "", rel: "noopener noreferrer" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.share($event)
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "7px",
            height: "13px",
            viewBox: "0 0 7 13",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("title", [_vm._v("Fill 1")]),
          _vm._v(" "),
          _c("desc", [_vm._v("Created with Sketch.")]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "Symbols",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Icons/Social_2",
                    transform: "translate(-86.000000, -5.000000)",
                    fill: "#BCBFC6"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M90.4619909,17.7472682 L90.4619909,12.1407227 L92.4881727,12.1407227 L92.7910818,9.95435909 L90.4619909,9.95435909 L90.4619909,8.55981364 C90.4619909,7.92813182 90.6509909,7.49558636 91.6278091,7.49558636 L92.8731727,7.49558636 L92.8731727,5.54145 C92.6568091,5.51604091 91.9186273,5.45517727 91.0582636,5.45517727 C89.2611727,5.45517727 88.0304455,6.47390455 88.0304455,8.34354091 L88.0304455,9.95435909 L85.9998091,9.95435909 L85.9998091,12.1407227 L88.0304455,12.1407227 L88.0304455,17.7472682 L90.4619909,17.7472682 Z",
                      id: "Fill-1"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }